import * as SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';
import store from '../store';
import { randomUuid } from './util'

export default new class {

    constructor() {
        this.ws = null;
        this.stompClient = null;
        this.isConnecting = false;
        this.isConnected = false;
        this.onConnecteds = [];
        this.onFails = [];
        this.subscribeMap = {};
    }

    connect(onConnected, onFail, options) {
        let id = null;
        if (onConnected) {
            id = id || randomUuid();
            const obj = { id: id, callback: onConnected, ...options };
            this.onConnecteds.push(obj);
        }
        if (onFail) {
            id = id || randomUuid();
            const obj = { id: id, callback: onFail, ...options };
            this.onFails.push(obj);
        }

        if (this.isConnected || this.isConnecting) {
            if (this.isConnected && onConnected) {
                onConnected(this.stompClient);
            }
            return id;
        }

        const accessToken = store.state.resource.auth.token
        this.isConnecting = true;
        this.ws = new SockJS(process.env.VUE_APP_WEBSOCKET_URL)
        this.stompClient = Stomp.over(this.ws)

        //this.stompClient.debug = null
        if (process.env.VUE_APP_DEBUG !== "true") {
            this.stompClient.debug = null
        }

        const header = {}
        if (accessToken) {
            header["Authorization"] = accessToken
        }
        this.stompClient.connect(header, (frame) => {
            this.isConnecting = false;
            this.isConnected = true;
            this.onConnecteds.forEach(onConnected => onConnected.callback(this.stompClient, frame));
        }, (frame) => {
            this.isConnecting = false;
            this.disconnect();
            this.onFails.forEach(onFail => onFail.callback(frame));
            setTimeout(() => {
                this.connect();
            }, 5000);
        })
        return id;
    }

    destroy(id) {
        this.onConnecteds = this.onConnecteds.filter(onConnected => onConnected.id !== id);
        this.onFails = this.onFails.filter(onFail => onFail.id !== id);
    }

    disconnect() {
        if (this.stompClient) {
            this.stompClient.disconnect();
        }
        this.subscribeMap = {};
        this.isConnected = false;
        this.stompClient = null;
        this.ws = null;
    }

    subscribe(path, onSubscribe) {
        if (!this.isConnected) {
            return null;
        }
        const obj = { id: null, path: path, callback: onSubscribe };
        if (this.subscribeMap[path]) {
            this.subscribeMap[path].onSubscribes.push(obj);
            return obj;
        }
        this.subscribeMap[path] = {
            onSubscribes: [obj]
        };
        const stompSubscribe = this.stompClient.subscribe(path,
            message => {
                if (this.subscribeMap[path]) {
                    this.subscribeMap[path].onSubscribes.forEach(onSubscribe => onSubscribe.callback(message));
                }
            }
        );
        obj.id = stompSubscribe.id
        return obj;
    }

    unsubscribe(path, id) {
        if (!this.isConnected) {
            return null;
        }
        if (!this.subscribeMap[path]) {
            return;
        }
        this.subscribeMap[path].onSubscribes = this.subscribeMap[path].onSubscribes.filter(onSubscribe => onSubscribe.id !== id);
        if (this.subscribeMap[path].onSubscribes.length === 0) {
            this.stompClient.unsubscribe(id);
            delete this.subscribeMap[path];
        }
    }

    send(path, header = {}, body) {
        if (!this.isConnected) {
            return null;
        }
        this.stompClient.send(
            path,
            header,
            body
        );
    }

    clearAll() {
        this.onConnecteds = this.onConnecteds.filter(d => d.force === true)
        this.onFails = this.onFails.filter(d => d.force === true)
        Object.keys(this.subscribeMap).forEach(path => this.subscribeMap[path].onSubscribes.forEach(d => this.unsubscribe(d.path, d.id)))
    }

}
